import React, { memo } from 'react';
import classNames from 'classnames';
import { TranscriptionMapper, TRANSCRIPTION_STATES } from './TranscriptionMapper';
import './styles.scss';

const SPEAKER_COLORS_COUNT = 6;

const speakerClass = (index) => `transcription-speaker-${index % SPEAKER_COLORS_COUNT}`;

const STATE_MESSAGES = {
  [TRANSCRIPTION_STATES.empty]: 'Transcription is empty',
  [TRANSCRIPTION_STATES.pending]: 'Transcription is not available yet',
  [TRANSCRIPTION_STATES.invalid]: 'Transcription could not be read',
};

export const TranscriptionDialog = memo(({ transcription }) => {
  const { state, text, speakers, messages } = transcription;

  if (state === TRANSCRIPTION_STATES.textOnly) {
    return <div className="transcription transcription-text">{text}</div>;
  }

  if (state !== TRANSCRIPTION_STATES.ready) {
    return <div className="transcription transcription-message">{STATE_MESSAGES[state]}</div>;
  }

  return (
    <div className="transcription">
      <div className="transcription-speakers">
        {speakers.map((speaker) => (
          <span key={speaker.name} className={classNames('transcription-speaker', speakerClass(speaker.index))}>
            {speaker.name}
            {speaker.durationMs !== null && (
              <span className="transcription-speaker-duration">{TranscriptionMapper.formatTime(speaker.durationMs)}</span>
            )}
          </span>
        ))}
      </div>

      <ul className="transcription-dialog">
        {messages.map((message) => (
          <li
            key={message.id}
            className={classNames('transcription-dialog-item', speakerClass(message.speakerIndex), {
              'transcription-dialog-item-right': message.speakerIndex % 2 === 1,
            })}
          >
            <div className="transcription-dialog-meta">
              <span className="transcription-dialog-name">{message.speaker}</span>
              {message.startMs !== null && <span className="transcription-dialog-time">{TranscriptionMapper.formatTime(message.startMs)}</span>}
            </div>
            <p className="transcription-dialog-text">{message.text}</p>
          </li>
        ))}
      </ul>
    </div>
  );
});
